import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { clsx, UserAvatar, UsersAutocompleteOption } from '@sweatpals/react-ui-kit';
import {
	sponsorCardAvatarStyles,
	sponsorCardStyles,
	sponsorNameStyles,
} from './sponsor-list.styles';

export interface SponsorCardProps {
	user: UsersAutocompleteOption;
	sx?: SxProps<Theme>;
	avatarSx?: SxProps<Theme>;
	emptyAvatarIconSize?: string;
	url?: string;
}

export const SponsorCard: FC<SponsorCardProps> = props => {
	const { user, sx, avatarSx, emptyAvatarIconSize = '32px', url } = props;

	const handleClick = () => {
		window.open(url, '_blank');
	};

	return (
		<Box sx={clsx(sponsorCardStyles, sx)} onClick={handleClick}>
			<UserAvatar {...user} sx={clsx(sponsorCardAvatarStyles, avatarSx)} emptyAvatarIconSize={emptyAvatarIconSize} />

			<Typography sx={sponsorNameStyles}>{user.fullName}</Typography>
		</Box>
	);
};
